import { h } from "preact";
import { RoutableProps } from "preact-router";
import "./styles.scss";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand } from "../../../hooks";
import { manufacturingConfigurations } from "../../../App";
import { stellaBIO } from "../../../data/serialNumberSearchExecs";
import { ProductLabelReprint } from "../../../components/ProductLabelReprint";

export function StellaBIOReprint(props: RoutableProps) {
    const showSnackbar = useCommand<SnackbarShowCommand>();

    return (
        <div class="stella-bio-reprint-page">
            <Snackbar doShow={showSnackbar} />
            <ProductLabelReprint
                showSnackbar={showSnackbar}
                configurations={manufacturingConfigurations["StellaBIO"]}
                execs={[stellaBIO.execs.elementSerialRegexPlain]}
                scanExecs={stellaBIO.orderedExecs}
                additionalAllowedProductTypes={["StellaBIO"]}
            />
        </div>
    );
}
